import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useTranslation } from '../i18n/LanguageContext'
import { supabase } from '../supabase'

const NAVY    = '#0B1F3A'
const TEAL    = '#2DD4B0'
const WHITE   = '#FFFFFF'
const W70     = 'rgba(255,255,255,0.70)'
const W40     = 'rgba(255,255,255,0.40)'
const W12     = 'rgba(255,255,255,0.12)'
const W08     = 'rgba(255,255,255,0.08)'
const RED_DIM = 'rgba(252,165,165,0.85)'

const ICONS = {
  dashboard: 'M3 5a2 2 0 012-2h3a1 1 0 010 2H5v3a1 1 0 01-2 0V5zm0 10a2 2 0 012-2h3a1 1 0 010 2H5v3a1 1 0 01-2 0v-3zm12-2a1 1 0 000 2h3v3a1 1 0 002 0v-3a2 2 0 00-2-2h-3zm0-10a1 1 0 000 2h3v3a1 1 0 002 0V5a2 2 0 00-2-2h-3z',
  orders:    'M9 2a1 1 0 000 2h2a1 1 0 100-2H9zM4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z',
  inventory: 'M4 3a2 2 0 100 4h12a2 2 0 100-4H4zM3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z',
  pos:       'M3 5a2 2 0 012-2h10a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm0 8a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2zm8 0a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z',
  crm:       'M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z',
  analytics: 'M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zm6-4a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zm6-3a1 1 0 00-1 1v11a1 1 0 001 1h2a1 1 0 001-1V5a1 1 0 00-1-1z',
  goals:     'M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zm6 0a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zm5 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V8a1 1 0 011-1z',
  events:    'M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z',
  invoices:  'M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z',
  finance:   'M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267zM10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z',
  website:   'M10 18a8 8 0 100-16 8 8 0 000 16zM4.332 8.027a6.012 6.012 0 011.912-2.706C6.512 5.73 6.974 6 7.5 6A1.5 1.5 0 019 7.5V8a2 2 0 004 0 2 2 0 011.523-1.943A5.977 5.977 0 0116 10c0 .34-.028.675-.08 1H15a2 2 0 00-2 2v2.197A5.973 5.973 0 0110 16v-2a2 2 0 00-2-2 2 2 0 01-2-2 2 2 0 00-1.668-1.973z',
  learn:     'M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z',
  tracking:  'M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z',
  pricing:   'M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z',
  settings:  'M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z',
  adboost:   'M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z',
  aimodel:   'M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z',
  logout:    'M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z',
  chevL:     'M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z',
  chevR:     'M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z',
  more:      'M4 10a2 2 0 114 0 2 2 0 01-4 0zm6 0a2 2 0 114 0 2 2 0 01-4 0zm6 0a2 2 0 114 0 2 2 0 01-4 0z',
  content:   'M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z',
  fbconnect: 'M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z',
}

function FlatIcon({ name, size = 17, color = W70 }) {
  if (name === 'tara') {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" style={{ flexShrink:0 }}>
        <path d="M12 2C12 2 12.8 7.5 14.5 9.5C16.2 11.5 22 12 22 12C22 12 16.2 12.5 14.5 14.5C12.8 16.5 12 22 12 22C12 22 11.2 16.5 9.5 14.5C7.8 12.5 2 12 2 12C2 12 7.8 11.5 9.5 9.5C11.2 7.5 12 2 12 2Z" fill={color}/>
        <path d="M19 3C19 3 19.4 5.2 20.2 6C21 6.8 23 7 23 7C23 7 21 7.2 20.2 8C19.4 8.8 19 11 19 11C19 11 18.6 8.8 17.8 8C17 7.2 15 7 15 7C15 7 17 6.8 17.8 6C18.6 5.2 19 3 19 3Z" fill={color} opacity="0.7"/>
        <path d="M5 16C5 16 5.25 17.3 5.75 17.75C6.25 18.25 7.5 18.5 7.5 18.5C7.5 18.5 6.25 18.75 5.75 19.25C5.25 19.75 5 21 5 21C5 21 4.75 19.75 4.25 19.25C3.75 18.75 2.5 18.5 2.5 18.5C2.5 18.5 3.75 18.25 4.25 17.75C4.75 17.3 5 16 5 16Z" fill={color} opacity="0.5"/>
      </svg>
    )
  }
  const d = ICONS[name]
  if (!d) return null
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill={color} style={{ flexShrink: 0 }}>
      <path fillRule="evenodd" d={d} clipRule="evenodd" />
    </svg>
  )
}

const PLAN_ORDER = ['trial','starter','growth','pro','business']

const FAVS_KEY     = 'pc_mobile_nav_favs_v1'
const DEFAULT_FAVS = ['/dashboard', '/orders', '/inventory', '/crm']

function getFavs() {
  try {
    const saved = JSON.parse(localStorage.getItem(FAVS_KEY))
    if (Array.isArray(saved) && saved.length > 0 && saved.every(p => typeof p === 'string')) return saved
  } catch {}
  return DEFAULT_FAVS
}

function Sidebar() {
  const navigate  = useNavigate()
  const location  = useLocation()
  const { seller, signOut, getSubscriptionPlan, getPlanLabel, subscriptionDaysLeft, isSubscriptionExpired } = useAuth()
  const { t, lang } = useTranslation()

  const [collapsed, setCollapsed] = useState(false)
  const [brandLogo, setBrandLogo] = useState(null)
  const [sellerLogo, setSellerLogo] = useState(null)
  const [favorites, setFavorites] = useState(getFavs)
  const [showMore, setShowMore]   = useState(false)

  const plan      = getSubscriptionPlan?.() || 'trial'
  const planLabel = getPlanLabel?.() || 'Trial'
  const daysLeft  = subscriptionDaysLeft?.()
  const expired   = isSubscriptionExpired?.()
  const isActive  = (path) => location.pathname.startsWith(path)

  useEffect(() => {
    supabase.from('admin_settings').select('value').eq('key', 'brand_logo_url').single()
      .then(({ data }) => { if (data?.value) setBrandLogo(data.value) })
  }, [])

  useEffect(() => {
    if (seller?.logo_url) setSellerLogo(seller.logo_url)
  }, [seller?.logo_url])

  useEffect(() => {
    try { localStorage.setItem(FAVS_KEY, JSON.stringify(favorites)) } catch {}
  }, [favorites])

  const daysColor = expired
    ? 'rgba(252,165,165,0.9)'
    : daysLeft !== null && daysLeft <= 3 ? 'rgba(252,165,165,0.9)'
    : daysLeft !== null && daysLeft <= 7 ? 'rgba(253,224,71,0.9)'
    : TEAL

  const daysText  = expired ? 'Expired' : daysLeft !== null ? daysLeft + 'd left' : ''
  const showRenew = expired || (daysLeft !== null && daysLeft <= 7)

  const isPlanAllowed = (req) => {
    if (!req) return true
    const ci = PLAN_ORDER.indexOf(plan)
    const ri = PLAN_ORDER.indexOf(req)
    return ci !== -1 && ri !== -1 && ci >= ri
  }

  const goTo = (item) => {
    const allowed = isPlanAllowed(item.plan)
    setShowMore(false)
    navigate(allowed ? item.path : '/pricing')
  }

  const toggleFavorite = (path) => {
    setFavorites(prev => {
      if (prev.includes(path)) return prev.filter(p => p !== path)
      if (prev.length >= 4) return [...prev.slice(1), path]
      return [...prev, path]
    })
  }

  const shopName = seller?.shop_name || 'My Shop'
  const initials = shopName.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()

  const NAV_GROUPS = [
    {
      label: lang === 'bn' ? 'সংক্ষিপ্ত' : 'Overview',
      items: [
        { icon: 'dashboard', label: t('nav.dashboard'), path: '/dashboard' },
      ],
    },
    {
      label: lang === 'bn' ? 'বিক্রি' : 'Sales',
      items: [
        { icon: 'orders',   label: t('nav.orders'),   path: '/orders' },
        { icon: 'pos',      label: t('nav.pos'),      path: '/pos',      plan: 'business' },
        { icon: 'invoices', label: t('nav.invoices'), path: '/invoices', plan: 'pro' },
        { icon: 'events',   label: t('nav.events'),   path: '/events',   plan: 'pro' },
      ],
    },
    {
      label: lang === 'bn' ? 'ব্যবস্থাপনা' : 'Manage',
      items: [
        { icon: 'inventory', label: t('nav.inventory'), path: '/inventory' },
        { icon: 'crm',       label: t('nav.crm'),       path: '/crm',     plan: 'growth' },
        { icon: 'finance',   label: t('nav.finance'),   path: '/finance' },
        { icon: 'goals',     label: t('nav.goals'),     path: '/goals' },
      ],
    },
    {
      label: lang === 'bn' ? 'প্রসার' : 'Grow',
      items: [
        { icon: 'analytics', label: t('nav.analytics'), path: '/analytics' },
        { icon: 'tara',      label: 'Ask Tara',         path: '/tara',         plan: 'growth' },
        { icon: 'aimodel',   label: 'AI Studio',        path: '/grow/aimodel', plan: 'pro' },
        { icon: 'website',   label: t('nav.website'),   path: '/website' },
        { icon: 'tracking',  label: t('nav.tracking'),  path: '/track' },
        { icon: 'learn',     label: t('nav.learn'),     path: '/learn' },
      ],
    },
    {
      label: lang === 'bn' ? 'মার্কেটিং' : 'Marketing',
      items: [
        { icon: 'content',   label: 'Content Studio',   path: '/marketing/content-studio' },
        { icon: 'fbconnect', label: 'Facebook Connect', path: '/marketing/fb-connect',     plan: 'pro' },
        { icon: 'adboost',   label: 'AdBoost',          path: '/grow/adboost',             plan: 'growth' },
      ],
    },
    {
      label: lang === 'bn' ? 'অ্যাকাউন্ট' : 'Account',
      items: [
        { icon: 'pricing',  label: t('nav.plans'),    path: '/pricing' },
        { icon: 'settings', label: t('nav.settings'), path: '/settings' },
      ],
    },
  ]

  const allFlat  = NAV_GROUPS.flatMap(g => g.items)
  const favItems = favorites.map(p => allFlat.find(i => i.path === p)).filter(Boolean)
  const fontFam  = lang === 'bn' ? 'Hind Siliguri, var(--font-ui)' : 'var(--font-ui)'

  return (
    <>
      <style>{`
        .pc-sidebar       { display:flex; flex-direction:column; flex-shrink:0; height:100vh; position:sticky; top:0; }
        .pc-sidebar-nav::-webkit-scrollbar { display:none; }
        .pc-nav-tooltip   { opacity:0; pointer-events:none; transition:opacity 0.12s; }
        .pc-nav-btn:hover .pc-nav-tooltip { opacity:1; }
        .pc-mobile-nav    { display:none!important; position:fixed; bottom:0; left:0; right:0; z-index:50; }
        .pc-more-sheet    { animation: pcSheetUp 0.2s ease-out; }
        .pc-more-overlay  { animation: pcFadeIn 0.2s ease-out; }
        @keyframes pcSheetUp { from { transform:translateY(100%); } to { transform:translateY(0); } }
        @keyframes pcFadeIn  { from { opacity:0; } to { opacity:1; } }
        @media(max-width:767px){
          .pc-sidebar    { display:none!important; }
          .pc-mobile-nav { display:flex!important; }
        }
      `}</style>

      {/* ── Desktop sidebar ── */}
      <aside className="pc-sidebar"
        style={{ width: collapsed ? '60px' : '224px', background: NAVY, transition: 'width 0.25s cubic-bezier(0.4,0,0.2,1)', overflowX: 'hidden', fontFamily: 'var(--font-ui)', borderRight: 'none', zIndex: 40 }}>

        {/* Brand */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: collapsed ? 'center' : 'flex-start', padding: collapsed ? '16px 0' : '16px 16px', borderBottom: '1px solid ' + W12, minHeight: '64px', flexShrink: 0 }}>
          {brandLogo ? (
            <img src={brandLogo} alt="PageConnect"
              style={{ height: collapsed ? '28px' : '42px', maxWidth: collapsed ? '32px' : '160px', objectFit: 'contain', transition: 'all 0.2s' }} />
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', overflow: 'hidden' }}>
              <div style={{ width: '36px', height: '36px', borderRadius: '10px', background: TEAL, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
                  <rect x="2" y="2" width="5" height="5" rx="1.5" fill={NAVY} />
                  <rect x="9" y="2" width="5" height="5" rx="1.5" fill={NAVY} />
                  <rect x="2" y="9" width="5" height="5" rx="1.5" fill={NAVY} />
                  <rect x="9" y="9" width="5" height="5" rx="1.5" fill={NAVY} opacity="0.35" />
                </svg>
              </div>
              {!collapsed && (
                <div style={{ overflow: 'hidden' }}>
                  <div style={{ fontSize: '15px', fontWeight: 800, color: WHITE, letterSpacing: '-0.3px', lineHeight: 1.2, whiteSpace: 'nowrap' }}>PageConnect</div>
                  <div style={{ fontSize: '10px', color: TEAL, fontWeight: 500, marginTop: '1px', whiteSpace: 'nowrap' }}>Business Suite</div>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Seller pill */}
        {!collapsed && (
          <div style={{ margin: '10px 10px 6px', padding: '10px 12px', borderRadius: '10px', background: W08, display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
            {sellerLogo ? (
              <img src={sellerLogo} alt={shopName} style={{ width: '30px', height: '30px', borderRadius: '8px', objectFit: 'cover', flexShrink: 0 }} />
            ) : (
              <div style={{ width: '30px', height: '30px', borderRadius: '8px', background: TEAL, color: NAVY, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 800, flexShrink: 0 }}>
                {initials}
              </div>
            )}
            <div style={{ minWidth: 0, flex: 1 }}>
              <div style={{ fontSize: '12px', fontWeight: 600, color: WHITE, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{shopName}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '2px' }}>
                <span style={{ fontSize: '10px', fontWeight: 700, color: TEAL }}>{planLabel}</span>
                {daysText && (
                  <>
                    <span style={{ fontSize: '9px', color: W40 }}>·</span>
                    <span style={{ fontSize: '10px', fontWeight: 600, color: daysColor }}>{daysText}</span>
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Renew banner */}
        {!collapsed && showRenew && (
          <button onClick={() => navigate('/pricing')}
            style={{ margin: '0 10px 8px', padding: '8px 12px', borderRadius: '9px', background: expired ? 'rgba(239,68,68,0.12)' : 'rgba(245,158,11,0.12)', border: '1px solid ' + (expired ? 'rgba(239,68,68,0.25)' : 'rgba(245,158,11,0.25)'), cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: 'calc(100% - 20px)', fontFamily: 'var(--font-ui)' }}>
            <span style={{ fontSize: '11px', color: expired ? 'rgba(252,165,165,0.9)' : 'rgba(253,224,71,0.9)', fontWeight: 500 }}>
              {expired ? 'Subscription expired' : daysLeft + ' days remaining'}
            </span>
            <span style={{ fontSize: '10.5px', fontWeight: 700, color: WHITE, background: expired ? 'rgba(239,68,68,0.5)' : 'rgba(245,158,11,0.5)', padding: '2px 8px', borderRadius: '20px' }}>
              Renew
            </span>
          </button>
        )}

        {/* Nav */}
        <nav className="pc-sidebar-nav"
          style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: collapsed ? '8px 8px' : '4px 8px', msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
          {NAV_GROUPS.map(group => (
            <div key={group.label} style={{ marginBottom: '2px' }}>
              {!collapsed && (
                <div style={{ padding: '10px 8px 4px', fontSize: '10px', fontWeight: 700, color: W40, letterSpacing: '0.1em', textTransform: 'uppercase', userSelect: 'none' }}>
                  {group.label}
                </div>
              )}
              {collapsed && <div style={{ height: '6px' }} />}
              {group.items.map(item => {
                const active  = isActive(item.path)
                const allowed = isPlanAllowed(item.plan)
                const planTag = item.plan === 'business' ? 'BIZ' : item.plan === 'growth' ? 'GROW' : item.plan ? 'PRO' : null

                return (
                  <button key={item.path}
                    onClick={() => allowed ? navigate(item.path) : navigate('/pricing')}
                    title={collapsed ? item.label : undefined}
                    className="pc-nav-btn"
                    style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '9px', padding: collapsed ? '9px 0' : '7px 8px', justifyContent: collapsed ? 'center' : 'flex-start', borderRadius: '8px', background: active ? W12 : 'transparent', border: 'none', borderLeft: active && !collapsed ? '2.5px solid ' + TEAL : '2.5px solid transparent', cursor: 'pointer', marginBottom: '1px', transition: 'all 0.12s', position: 'relative', fontFamily: 'var(--font-ui)' }}
                    onMouseEnter={e => { if (!active) e.currentTarget.style.background = W08 }}
                    onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'transparent' }}>

                    <FlatIcon name={item.icon} size={17} color={active ? (item.icon==='tara'?TEAL:WHITE) : allowed ? W70 : W40} />

                    {!collapsed && (
                      <span style={{ fontSize: '13px', fontWeight: active ? 600 : 400, color: active ? WHITE : allowed ? W70 : W40, flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: fontFam }}>
                        {item.label}
                      </span>
                    )}

                    {active && !collapsed && (
                      <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: TEAL, flexShrink: 0 }} />
                    )}

                    {!collapsed && planTag && !allowed && (
                      <span style={{ fontSize: '9px', fontWeight: 700, padding: '2px 5px', borderRadius: '4px', background: W08, color: W40, flexShrink: 0, letterSpacing: '0.03em' }}>
                        {planTag}
                      </span>
                    )}

                    {collapsed && (
                      <div className="pc-nav-tooltip"
                        style={{ position: 'absolute', left: 'calc(100% + 12px)', top: '50%', transform: 'translateY(-50%)', background: '#1a3554', color: WHITE, fontSize: '12px', fontWeight: 500, padding: '6px 12px', borderRadius: '8px', whiteSpace: 'nowrap', zIndex: 200, boxShadow: '0 4px 16px rgba(0,0,0,0.3)', border: '1px solid ' + W12 }}>
                        {item.label}
                        <div style={{ position: 'absolute', left: '-4px', top: '50%', transform: 'translateY(-50%)', width: '8px', height: '8px', background: '#1a3554', border: '1px solid ' + W12, borderRight: 'none', borderBottom: 'none', rotate: '-45deg' }} />
                      </div>
                    )}
                  </button>
                )
              })}
            </div>
          ))}
        </nav>

        {/* Bottom */}
        <div style={{ flexShrink: 0, borderTop: '1px solid ' + W12, padding: collapsed ? '10px 8px' : '10px 8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <button onClick={() => setCollapsed(!collapsed)}
            style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: collapsed ? '8px 0' : '7px 8px', justifyContent: collapsed ? 'center' : 'flex-start', borderRadius: '8px', background: 'transparent', border: 'none', cursor: 'pointer', width: '100%', fontFamily: 'var(--font-ui)' }}
            onMouseEnter={e => e.currentTarget.style.background = W08}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            <FlatIcon name={collapsed ? 'chevR' : 'chevL'} size={16} color={W40} />
            {!collapsed && <span style={{ fontSize: '12px', color: W40 }}>{t('nav.collapse')}</span>}
          </button>

          <button onClick={signOut}
            style={{ display: 'flex', alignItems: 'center', gap: '9px', padding: collapsed ? '8px 0' : '7px 8px', justifyContent: collapsed ? 'center' : 'flex-start', borderRadius: '8px', background: 'transparent', border: 'none', cursor: 'pointer', width: '100%', fontFamily: 'var(--font-ui)' }}
            onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.12)'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
            <FlatIcon name="logout" size={16} color={RED_DIM} />
            {!collapsed && <span style={{ fontSize: '12px', color: RED_DIM, fontWeight: 500 }}>{t('nav.logout')}</span>}
          </button>
        </div>
      </aside>

      {/* ── Mobile bottom nav ── */}
      <nav className="pc-mobile-nav"
        style={{ background: NAVY, borderTop: '1px solid ' + W12, alignItems: 'center', padding: '6px 4px', paddingBottom: 'calc(6px + env(safe-area-inset-bottom))', gap: '2px' }}>
        {favItems.map(item => {
          const active  = isActive(item.path)
          const allowed = isPlanAllowed(item.plan)
          return (
            <button key={item.path} onClick={() => navigate(allowed ? item.path : '/pricing')}
              style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', padding: '5px 2px', borderRadius: '10px', background: active ? W12 : 'transparent', border: 'none', cursor: 'pointer' }}>
              <FlatIcon name={item.icon} size={20} color={active ? WHITE : allowed ? W70 : W40} />
              <span style={{ fontSize: '10px', color: active ? WHITE : allowed ? W70 : W40, fontWeight: active ? 600 : 400, fontFamily: fontFam, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                {item.label}
              </span>
            </button>
          )
        })}
        <button onClick={() => setShowMore(true)}
          style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', padding: '5px 2px', borderRadius: '10px', background: 'transparent', border: 'none', cursor: 'pointer' }}>
          <FlatIcon name="more" size={20} color={W70} />
          <span style={{ fontSize: '10px', color: W70, fontWeight: 400, fontFamily: fontFam }}>
            {lang === 'bn' ? 'আরও' : 'More'}
          </span>
        </button>
      </nav>

      {/* ── More sheet ── */}
      {showMore && (
        <>
          <div className="pc-more-overlay" onClick={() => setShowMore(false)}
            style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 60 }} />
          <div className="pc-more-sheet"
            style={{ position: 'fixed', left: 0, right: 0, bottom: 0, maxHeight: '78vh', overflowY: 'auto', background: NAVY, borderRadius: '16px 16px 0 0', zIndex: 61, paddingBottom: 'calc(10px + env(safe-area-inset-bottom))', fontFamily: 'var(--font-ui)' }}>

            <div onClick={() => setShowMore(false)} style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 2px', cursor: 'pointer' }}>
              <div style={{ width: '36px', height: '4px', borderRadius: '2px', background: W12 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '4px 16px 8px' }}>
              <span style={{ fontSize: '13px', fontWeight: 700, color: WHITE }}>{lang === 'bn' ? 'মেনু' : 'Menu'}</span>
              <button onClick={() => setShowMore(false)}
                style={{ background: W08, border: 'none', borderRadius: '8px', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke={W70} strokeWidth="2.2" strokeLinecap="round"><path d="M5 5l10 10M15 5L5 15"/></svg>
              </button>
            </div>
            <div style={{ padding: '0 16px 6px', fontSize: '11px', color: W40 }}>
              {lang === 'bn' ? 'বটম বারে পিন করতে ★ ট্যাপ করুন' : 'Tap ★ to pin to bottom bar'}
            </div>

            {NAV_GROUPS.map(group => (
              <div key={group.label}>
                <div style={{ padding: '8px 16px 4px', fontSize: '10px', fontWeight: 700, color: W40, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
                  {group.label}
                </div>
                {group.items.map(item => {
                  const allowed  = isPlanAllowed(item.plan)
                  const planTag  = item.plan === 'business' ? 'BIZ' : item.plan === 'growth' ? 'GROW' : item.plan ? 'PRO' : null
                  const isFav    = favorites.includes(item.path)
                  const active   = isActive(item.path)
                  return (
                    <div key={item.path} onClick={() => goTo(item)}
                      style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 16px', cursor: 'pointer', background: active ? W08 : 'transparent' }}>
                      <FlatIcon name={item.icon} size={18} color={allowed ? (item.icon==='tara'?TEAL:W70) : W40} />
                      <span style={{ flex: 1, fontSize: '14px', color: allowed ? WHITE : W40, fontFamily: fontFam, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {item.label}
                      </span>
                      {!allowed && planTag && (
                        <span style={{ fontSize: '9px', fontWeight: 700, padding: '2px 5px', borderRadius: '4px', background: W08, color: W40, letterSpacing: '0.03em', flexShrink: 0 }}>
                          {planTag}
                        </span>
                      )}
                      <button onClick={(e) => { e.stopPropagation(); toggleFavorite(item.path) }}
                        style={{ background: 'none', border: 'none', padding: '6px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FlatIcon name="adboost" size={16} color={isFav ? TEAL : W40} />
                      </button>
                    </div>
                  )
                })}
              </div>
            ))}

            <div style={{ borderTop: '1px solid ' + W12, marginTop: '4px' }}>
              <div onClick={() => { setShowMore(false); navigate('/settings') }}
                style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 16px', cursor: 'pointer' }}>
                <FlatIcon name="settings" size={18} color={W70} />
                <span style={{ flex: 1, fontSize: '14px', color: WHITE, fontFamily: fontFam }}>{t('nav.settings')}</span>
              </div>
              <div onClick={signOut}
                style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '11px 16px', cursor: 'pointer' }}>
                <FlatIcon name="logout" size={18} color={RED_DIM} />
                <span style={{ flex: 1, fontSize: '14px', color: RED_DIM, fontWeight: 500, fontFamily: fontFam }}>{t('nav.logout')}</span>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Sidebar